import axios from 'axios';

const API = axios.create({
  baseURL: '/api',
});

// ===== Auth: anexa token e trata 401 (sessão expirada) =====
export const AUTH_TOKEN_KEY = 'warrom_auth_token';
export const AUTH_USER_KEY = 'warrom_auth_user';

API.interceptors.request.use((config) => {
  const token = localStorage.getItem(AUTH_TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

API.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response && err.response.status === 401) {
      // não desloga durante a própria tentativa de login
      const url = err.config?.url || '';
      if (!url.includes('/auth/login')) {
        localStorage.removeItem(AUTH_TOKEN_KEY);
        localStorage.removeItem(AUTH_USER_KEY);
        if (window.location.pathname !== '/login') window.location.assign('/login');
      }
    }
    return Promise.reject(err);
  }
);

// ===== Auth API =====
export const apiLogin = (username, password) => API.post('/auth/login', { username, password });
export const apiMe = () => API.get('/auth/me');
export const apiListUsers = () => API.get('/auth/users');
export const apiCreateUser = ({ username, password, role, nome }) =>
  API.post('/auth/users', { username, password, role, nome });
export const apiDeleteUser = (id) => API.delete(`/auth/users/${id}`);
export const apiResetPassword = (id, password) => API.post(`/auth/users/${id}/password`, { password });

// ===== Metas (self-service por loja) =====
export const apiListMetas = () => API.get('/metas');
export const apiSetMeta = ({ loja_slug, metric_key, valor }) =>
  API.post('/metas', { loja_slug, metric_key, valor });
export const apiListEquipes = () => API.get('/metas/equipes');
export const apiSetEquipe = ({ loja_slug, field, valor }) =>
  API.post('/metas/equipes', { loja_slug, field, valor });
// Meta GERAL do site (E-commerce) B2C/B2B — usada no "esperado" dos slides do site.
export const getSiteMeta = () => API.get('/metas/site');
export const saveSiteMeta = ({ canal, valor }) => API.post('/metas/site', { canal, valor });

// === Roteiro da apresentação (IA) — texto salvo por slide ===
export const getRoteiros = () => API.get('/roteiro/');
export const syncRoteiros = (slides) => API.post('/roteiro/sync', { slides });
export const generateRoteiro = (slide) => API.post('/roteiro/generate', slide);
export const saveRoteiro = (key, texto) => API.put(`/roteiro/${encodeURIComponent(key)}`, { texto });

export const uploadGSPN = (file, ascCode = '2326126', nomeLoja = 'Tatuapé') => {
  const form = new FormData();
  form.append('file', file);
  return API.post(`/upload/gspn?asc_code=${ascCode}&nome_loja=${nomeLoja}`, form);
};

export const uploadQless = (file, ascCode = '2326126', nomeLoja = 'Tatuapé') => {
  const form = new FormData();
  form.append('file', file);
  return API.post(`/upload/qless?asc_code=${ascCode}&nome_loja=${nomeLoja}`, form);
};

export const uploadGD = (file, ascCode = '2326126', nomeLoja = 'Tatuapé') => {
  const form = new FormData();
  form.append('file', file);
  return API.post(`/upload/gd?asc_code=${ascCode}&nome_loja=${nomeLoja}`, form);
};

export const uploadOneStop = (file, ascCode = '2326126', nomeLoja = 'Tatuapé') => {
  const form = new FormData();
  form.append('file', file);
  return API.post(`/upload/one_stop?asc_code=${ascCode}&nome_loja=${nomeLoja}`, form);
};

export const uploadStockRepair = (file, ascCode = '2326126', nomeLoja = 'Tatuapé') => {
  const form = new FormData();
  form.append('file', file);
  return API.post(`/upload/stock_repair?asc_code=${ascCode}&nome_loja=${encodeURIComponent(nomeLoja)}`, form);
};

export const uploadBacklog = (file, ascCode = '2326126', nomeLoja = 'Tatuapé') => {
  const form = new FormData();
  form.append('file', file);
  return API.post(`/upload/backlog?asc_code=${ascCode}&nome_loja=${encodeURIComponent(nomeLoja)}`, form);
};

// === BACKLOG — MAPEAMENTO ===

export const getBacklogMapping = () => API.get('/backlog/mapping');

export const getBacklogDistintos = (ascCode) =>
  API.get(`/backlog/mapping/distintos?asc_code=${encodeURIComponent(ascCode)}`);

export const putBacklogFiltros = (abaKey, filtrosTipoServico, actor = 'admin') =>
  API.put(`/backlog/mapping/filtros?actor=${encodeURIComponent(actor)}`, {
    aba_key: abaKey, filtros_tipo_servico: filtrosTipoServico,
  });

export const deleteBacklogFiltros = (abaKey) =>
  API.delete(`/backlog/mapping/filtros/${encodeURIComponent(abaKey)}`);

export const putBacklogStatus = (statusExcluidos, actor = 'admin') =>
  API.put(`/backlog/mapping/status?actor=${encodeURIComponent(actor)}`, {
    status_excluidos: statusExcluidos,
  });

export const deleteBacklogStatus = () => API.delete('/backlog/mapping/status');

export const getDashboard = (ascCode = '2326126', dataInicio, dataFim) => {
  const params = new URLSearchParams({ asc_code: ascCode });
  if (dataInicio) params.append('data_inicio', dataInicio);
  if (dataFim) params.append('data_fim', dataFim);
  return API.get(`/dashboard/?${params}`);
};

export const getLojas = () => API.get('/dashboard/lojas');

export const getDistintos = (ascCode) =>
  API.get(`/dashboard/distintos?asc_code=${encodeURIComponent(ascCode)}`);

export const getVisibility = () => API.get('/config/visibility');
export const setVisibility = (hidden) => API.post('/config/visibility', { hidden });
export const getMetricOrder = () => API.get('/config/metric-order');
export const setMetricOrder = (order) => API.post('/config/metric-order', { order });
// Slides personalizados (texto/observações) globais do Modo Apresentação.
export const getCustomSlides = () => API.get('/config/custom-slides');
export const saveCustomSlides = (slides) => API.post('/config/custom-slides', { slides });
export const getGdProjection = () => API.get('/config/gd-projection');
export const setGdProjection = (factors) => API.post('/config/gd-projection', { factors });

export const getUploads = (ascCode = '2326126') =>
  API.get(`/dashboard/uploads?asc_code=${ascCode}`);

// Última atualização (MAX data_upload) por loja e por tipo de upload
export const getLastUpdates = () => API.get('/uploads/last-updates');

// === APROVAÇÕES ===

export const uploadAprovacoes = (file, empresaSlug, ascCode, nomeLoja = '') => {
  const form = new FormData();
  form.append('file', file);
  return API.post(
    `/aprovacoes/upload?empresa_slug=${empresaSlug}&asc_code=${ascCode}&nome_loja=${encodeURIComponent(nomeLoja)}`,
    form
  );
};

// === APROVAÇÕES — BUNDLE (multi-arquivo) ===

export const getAprovacoesUploadsRequired = (empresaSlug) =>
  API.get(`/aprovacoes/config/uploads-required?empresa_slug=${encodeURIComponent(empresaSlug)}`);

export const validateAprovacaoFile = (file, empresaSlug, tipo) => {
  const form = new FormData();
  form.append('file', file);
  return API.post(
    `/aprovacoes/validate?empresa_slug=${encodeURIComponent(empresaSlug)}&tipo=${encodeURIComponent(tipo)}`,
    form
  );
};

export const uploadAprovacoesBundle = ({ empresaSlug, ascCode, nomeLoja = '', files }) => {
  const form = new FormData();
  form.append('file_aprovacoes', files.aprovacoes);
  if (files.pecas) form.append('file_pecas', files.pecas);
  if (files.mao_obra) form.append('file_mao_obra', files.mao_obra);
  if (files.notas) form.append('file_notas', files.notas);
  if (files.ov) form.append('file_ov', files.ov);   // opcional (JMV): Relatório peça OV
  return API.post(
    `/aprovacoes/upload-bundle?empresa_slug=${encodeURIComponent(empresaSlug)}&asc_code=${encodeURIComponent(ascCode)}&nome_loja=${encodeURIComponent(nomeLoja)}`,
    form
  );
};

// Só o Relatório peça OV (JMV) — sem reenviar os outros arquivos.
export const uploadAprovacoesOv = ({ empresaSlug, ascCode, nomeLoja = '', file }) => {
  const form = new FormData();
  form.append('file', file);
  return API.post(
    `/aprovacoes/upload-ov?empresa_slug=${encodeURIComponent(empresaSlug)}&asc_code=${encodeURIComponent(ascCode)}&nome_loja=${encodeURIComponent(nomeLoja)}`,
    form
  );
};

export const getAprovacoesData = (empresaSlug, ascCode, dataInicio, dataFim) => {
  const params = new URLSearchParams({ empresa_slug: empresaSlug, asc_code: ascCode });
  if (dataInicio) params.append('data_inicio', dataInicio);
  if (dataFim) params.append('data_fim', dataFim);
  return API.get(`/aprovacoes/dashboard?${params}`);
};

export const getSalesDay = (dataInicio, dataFim) => {
  const params = new URLSearchParams();
  if (dataInicio) params.append('data_inicio', dataInicio);
  if (dataFim) params.append('data_fim', dataFim);
  return API.get(`/aprovacoes/sales-day?${params}`);
};

export const getAprovacoesConfigs = () => API.get('/aprovacoes/configs');
export const setAprovacaoThreshold = (empresaSlug, abaKey, threshold, comparison, actor = '', minValue = null, metaAprovacao = null, metaReceita = null) =>
  API.post(`/aprovacoes/threshold?actor=${encodeURIComponent(actor)}`, {
    empresa_slug: empresaSlug, aba_key: abaKey,
    threshold, comparison, min_value: minValue,
    meta_aprovacao: metaAprovacao, meta_receita: metaReceita,
  });
export const deleteAprovacaoThreshold = (empresaSlug, abaKey) =>
  API.delete(`/aprovacoes/threshold/${empresaSlug}/${encodeURIComponent(abaKey)}`);

// === APROVAÇÕES — MAPEAMENTO ===

export const getAprovacoesMapping = () => API.get('/aprovacoes/mapping');

export const getAprovacoesMappingDistintos = (empresaSlug, ascCode) =>
  API.get(`/aprovacoes/mapping/distintos?empresa_slug=${encodeURIComponent(empresaSlug)}&asc_code=${encodeURIComponent(ascCode)}`);

export const putAprovacaoFiltros = (empresaSlug, abaKey, filtros, actor = 'admin') =>
  API.put(`/aprovacoes/mapping/filtros?actor=${encodeURIComponent(actor)}`, {
    empresa_slug: empresaSlug, aba_key: abaKey, filtros,
  });

export const deleteAprovacaoFiltros = (empresaSlug, abaKey) =>
  API.delete(`/aprovacoes/mapping/filtros/${empresaSlug}/${encodeURIComponent(abaKey)}`);

export const putAprovacaoStatus = (empresaSlug, payload, actor = 'admin') =>
  API.put(`/aprovacoes/mapping/status?actor=${encodeURIComponent(actor)}`, {
    empresa_slug: empresaSlug, ...payload,
  });

export const deleteAprovacaoStatus = (empresaSlug) =>
  API.delete(`/aprovacoes/mapping/status/${empresaSlug}`);

export const putAprovacaoOps = (empresaSlug, abaKey, opsAceitos, actor = 'admin') =>
  API.put(`/aprovacoes/mapping/op?actor=${encodeURIComponent(actor)}`, {
    empresa_slug: empresaSlug, aba_key: abaKey, ops_aceitos: opsAceitos,
  });

export const deleteAprovacaoOps = (empresaSlug, abaKey) =>
  API.delete(`/aprovacoes/mapping/op/${encodeURIComponent(empresaSlug)}/${encodeURIComponent(abaKey)}`);

export const resetAprovacaoMapping = (empresaSlug, scope = 'all', abaKey = null) =>
  API.post('/aprovacoes/mapping/reset', {
    empresa_slug: empresaSlug, scope, aba_key: abaKey,
  });

// === Headcount manual (recepcionistas + técnicos por loja/mês) ===
export const getHeadcount = (year, month) =>
  API.get(`/headcount/?year=${year}&month=${month}`);
export const saveHeadcount = (payload, actor = '') =>
  API.post(`/headcount/?actor=${encodeURIComponent(actor)}`, payload);

// === Store+ / SMB (entrada manual) ===
export const getStorePlusSMB = (year, month) =>
  API.get(`/store-plus-smb/?year=${year}&month=${month}`);
export const saveStorePlusSMB = (payload, actor = '') =>
  API.post(`/store-plus-smb/?actor=${encodeURIComponent(actor)}`, payload);

// === Venda de Acessórios ===
// Total faturado em acessórios no período (JMV/CSP/MSC vêm do import; VIP do registro manual)
export const getAcessorios = (ascCode, dataInicio, dataFim) => {
  const params = new URLSearchParams({ asc_code: ascCode });
  if (dataInicio) params.append('data_inicio', dataInicio);
  if (dataFim) params.append('data_fim', dataFim);
  return API.get(`/acessorios?${params}`);
};

export const getSeminovos = (ascCode, dataInicio, dataFim) => {
  const params = new URLSearchParams({ asc_code: ascCode });
  if (dataInicio) params.append('data_inicio', dataInicio);
  if (dataFim) params.append('data_fim', dataFim);
  return API.get(`/seminovos?${params}`);
};

export const saveSeminovosMeta = ({ ascCode, valor, categoria = 'mx' }, actor = 'admin') => {
  return API.post(`/seminovos/meta?actor=${actor}`, { asc_code: ascCode, valor, categoria });
};
// Valor manual (VIP) por loja/ano/mês
export const getAcessoriosManual = (ascCode, ano, mes) =>
  API.get(`/acessorios/manual?asc_code=${encodeURIComponent(ascCode)}&ano=${ano}&mes=${mes}`);
export const saveAcessoriosManual = ({ ascCode, ano, mes, valor }, actor = '') =>
  API.post(`/acessorios/manual?actor=${encodeURIComponent(actor)}`, {
    asc_code: ascCode, ano, mes, valor,
  });
// Meta mensal (R$) de acessórios por loja
export const saveAcessoriosMeta = ({ ascCode, valor }, actor = '') =>
  API.post(`/acessorios/meta?actor=${encodeURIComponent(actor)}`, { asc_code: ascCode, valor });
// Lista de acessórios vendidos no período (NF, produto, cliente, valor, data, OS)
export const getAcessoriosItens = (ascCode, dataInicio, dataFim) => {
  const params = new URLSearchParams({ asc_code: ascCode });
  if (dataInicio) params.append('data_inicio', dataInicio);
  if (dataFim) params.append('data_fim', dataFim);
  return API.get(`/acessorios/itens?${params}`);
};

// === B2B / B2C analytics ===
export const getB2BAnalytics = (dataInicio, dataFim) => {
  const params = new URLSearchParams();
  if (dataInicio) params.append('data_inicio', dataInicio);
  if (dataFim) params.append('data_fim', dataFim);
  return API.get(`/b2b/analytics?${params}`);
};

export const getB2BRules = () => API.get('/b2b/rules');
export const createB2BRule = (payload, actor = '') =>
  API.post(`/b2b/rules?actor=${encodeURIComponent(actor)}`, payload);
export const updateB2BRule = (id, payload, actor = '') =>
  API.put(`/b2b/rules/${id}?actor=${encodeURIComponent(actor)}`, payload);
export const deleteB2BRule = (id, actor = '') =>
  API.delete(`/b2b/rules/${id}?actor=${encodeURIComponent(actor)}`);
export const getB2BAudit = (ruleId, limit = 50) => {
  const params = new URLSearchParams({ limit });
  if (ruleId) params.append('rule_id', ruleId);
  return API.get(`/b2b/rules/audit?${params}`);
};
export const getB2BPreview = (dataInicio, dataFim, unit, site, limit = 200) => {
  const params = new URLSearchParams({ limit });
  if (dataInicio) params.append('data_inicio', dataInicio);
  if (dataFim) params.append('data_fim', dataFim);
  if (unit) params.append('unit', unit);
  if (site) params.append('site', site);
  return API.get(`/b2b/preview?${params}`);
};

export const getAprovacoesOSList = (empresaSlug, ascCode, abaKey, dataInicio, dataFim, apenasAprovadas = false) => {
  const params = new URLSearchParams({
    empresa_slug: empresaSlug,
    asc_code: ascCode,
    aba_key: abaKey,
    apenas_aprovadas: apenasAprovadas,
  });
  if (dataInicio) params.append('data_inicio', dataInicio);
  if (dataFim) params.append('data_fim', dataFim);
  return API.get(`/aprovacoes/os-list?${params}`);
};

export default API;
